import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SetDefaultWidgetMutation } from "../graphql/mutations";
import type {
  SetDefaultWidgetMutationType,
  SetDefaultWidgetMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useSetDefaultWidgetMutation = (
  options?: MutationHookOptions<
    SetDefaultWidgetMutationType,
    SetDefaultWidgetMutationVariablesType
  >
) => {
  return useMutation<
    SetDefaultWidgetMutationType,
    SetDefaultWidgetMutationVariablesType
  >(SetDefaultWidgetMutation, options);
};
